// Environment configuration
export const config = {
  // Primary source: Vite env vars. Fallbacks are localhost for dev convenience.
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || "http://localhost:3000/api",
  backendUrl: import.meta.env.VITE_BACKEND_URL || "http://localhost:3000",
  frontendUrl: import.meta.env.VITE_FRONTEND_URL || "http://localhost:5175",
  apiDocsUrl: import.meta.env.VITE_API_DOCS_URL || "http://localhost:3000/api",
  nodeEnv: import.meta.env.VITE_NODE_ENV || "development",
  debugMode: import.meta.env.VITE_DEBUG_MODE === "true",
  logLevel: import.meta.env.VITE_LOG_LEVEL || "debug",
};

// Axios instance configuration
export const apiConfig = {
  baseURL: config.apiBaseUrl,
  timeout: 30000, // Reduced from 100000ms to 30000ms (30 seconds) for better performance
  headers: {
    "Content-Type": "application/json",
  },
};

// Debug logging
export const log = {
  debug: (...args: any[]) => {
    if (config.debugMode) {
      console.log("[DEBUG]", ...args);
    }
  },
  error: (...args: any[]) => {
    if (config.logLevel === "debug" || config.logLevel === "error") {
      console.error("[ERROR]", ...args);
    }
  },
  info: (...args: any[]) => {
    if (config.debugMode) {
      console.info("[INFO]", ...args);
    }
  },
  warn: (...args: any[]) => {
    if (config.debugMode) {
      console.warn("[WARN]", ...args);
    }
  },
};

// Environment info
export const getEnvironmentInfo = () => {
  return {
    environment: config.nodeEnv,
    apiUrl: config.apiBaseUrl,
    backendUrl: config.backendUrl,
    frontendUrl: config.frontendUrl,
    debugMode: config.debugMode,
    logLevel: config.logLevel,
  };
};

// Log environment info on startup
if (config.debugMode) {
  console.log("🚀 Environment Configuration:", getEnvironmentInfo());
  console.log(
    "ℹ️ You can override the API base URL at runtime by setting window.__API_BASE_URL = 'http://localhost:3000/api' in the browser console before reloading."
  );
}

// Runtime getter that respects a manual override via window.__API_BASE_URL
export const getEffectiveApiBaseUrl = (): string => {
  try {
    // Priority 1: runtime window override (temporary)
    // Priority 2: localStorage override (persists across reloads)
    // @ts-ignore - window/localStorage used only in browser
    const windowOverride = (typeof window !== "undefined" &&
      (window as any).__API_BASE_URL) as string | undefined;
    if (
      windowOverride &&
      typeof windowOverride === "string" &&
      windowOverride.length > 0
    ) {
      return windowOverride;
    }
    // @ts-ignore
    const storageOverride = (typeof localStorage !== "undefined" &&
      localStorage.getItem("__API_BASE_URL")) as string | null;
    if (storageOverride && storageOverride.length > 0) {
      return storageOverride;
    }
  } catch (err) {
    // ignore
  }
  return config.apiBaseUrl;
};
